export default class MobileMenu {
    constructor(elm) {

        this.header = elm;

        this.header.querySelector('.burger-menu-close').addEventListener('click', e => {
            e.preventDefault();
            document.body.classList.remove('mobile-menu-open');
        });
    }
}
